import { required, minLength, maxLength } from "vuelidate/lib/validators";

export default {
  name: "agent_info",

  data() {
    return {
      agentLicense: "",
      agree: "",
      firmName: ""
    };
  },

  validations() {
    let params = {
      agentLicense: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(64)
      },

      firmName: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(64)
      }
    };

    return params;
  },

  props: [],

  mounted: function() {
    if (localStorage.getItem("searchParams")) {
      localStorage.removeItem("searchParams");
    }
  },

  methods: {
    submitForm() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        localStorage.setItem(
          "signupAgentInfo",
          JSON.stringify({
            licensse: this.agentLicense,
            firmName: this.firmName
          })
        );

        this.$router.push({
          name: "sign_up"
        });
      }
    },

    changeAgree(value) {
      this.agree = value ? value : "";
    }
  },

  components: {}
};
